import { Divider, ListItem, ListItemText, Stack, Typography } from "@mui/material";

type Props = {
    detail: PipelineError[];
}

export type PipelineError = {
    error: string,
    error_code: number,
    description: string,
}

const ErrorList = (props: Props): JSX.Element => {
    return (
        <Stack>
            <Divider />
            <Typography variant={'h4'}>{"List of Errors:"}</Typography>
            {props.detail.map(error => (
                <ListItem>
                    <ListItemText
                        primary={
                            error.error + ": " +
                            error.error_code
                        }
                        secondary={
                            error.description
                        }>
                    </ListItemText>
                </ListItem>
            ))}
        </Stack>
    )
}

export default ErrorList;